export const MENU_TYPE_MEGA_MENU = 'mega-menu';
